import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./recipient-list-filter.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./recipient-list-filter.component.scss?ngResource";
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from "@angular/core";
import * as RecipientListFilterConstants from "./recipient-list-filter.constants";
import { CRUDOperation } from "../../../models/crud-operation-enum.model";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../models/alert";
import { SharedConstants } from "../../../constants/shared.constants";
import { RecipientListService } from "../shared/recipient-list.service";
import { RequestStatusService } from "../../../services/request-status/request-status.service";
import { take } from "rxjs";
let RecipientListFilterComponent = class RecipientListFilterComponent {
    changeDetectorRef;
    recipientListService;
    requestStatusService;
    appControllerService;
    stepMetaRecipientGroups;
    addRecipientClicked = new EventEmitter();
    addAllRecipientsClicked = new EventEmitter();
    configurableLabel;
    jobId;
    displayGroupsPlaceTextHolder = RecipientListFilterConstants.DISPLAY_GROUPS_TEXT_PLACEHOLDER;
    selectGroupsPlaceTextHolder = RecipientListFilterConstants.SELECT_GROUPS_TEXT_PLACEHOLDER;
    groupsForTheGroupsDropdown = [SharedConstants.FILTER_DEFAULT];
    recipientsForTheRecipientsDropdown = [];
    displayFilterGroups;
    addAllBtnPlaceholder = RecipientListFilterConstants.ADD_ALL_GROUPS_BTN_PLACEHOLDER;
    selectedRecipientFromDropdown;
    noRecipientSelectedErrMsg = RecipientListFilterConstants.NO_RECIPIENT_SELECTED_ERR_MSG;
    selectedGroupFromDropdown;
    recipients;
    componentName = RecipientListFilterConstants.COMPONENT_NAME;
    noGroupsDetectedErrMsg = RecipientListFilterConstants.NO_GROUPS_DETECTED_ERR_MSG;
    groupNameUndefinedErrMsg = RecipientListFilterConstants.GROUPNAME_UNDEFINED_ERR_MSG;
    getRecipientsByGroupSubscription;
    constructor(changeDetectorRef, recipientListService, requestStatusService, appControllerService) {
        this.changeDetectorRef = changeDetectorRef;
        this.recipientListService = recipientListService;
        this.requestStatusService = requestStatusService;
        this.appControllerService = appControllerService;
    }
    ngOnInit() {
        this.populateGroupsSelect();
        this.loadDefaultGroup();
    }
    ngOnChanges(changes) {
        if (changes && changes.hasOwnProperty("stepMetaRecipientGroups") && changes.stepMetaRecipientGroups.currentValue && changes.stepMetaRecipientGroups.currentValue.length > 0) {
            const groups = changes.stepMetaRecipientGroups.currentValue;
            this.stepMetaRecipientGroups = groups;
            this.getRecipients(groups);
        }
    }
    loadDefaultGroup() {
        this.recipientListService.emitRecipient.pipe(take(1)).subscribe(x => {
            this.filterRecipientsOnGroupsSelectChange(x);
        });
    }
    onDisplayGroupsChangedChecked($event) {
        const displayGroupsChecked = $event.target.checked;
        if (displayGroupsChecked) {
            this.displayFilterGroups = true;
        }
        else {
            this.displayFilterGroups = false;
        }
        this.sortGroupsAlphabetically();
    }
    onGroupsDropDownChanged() {
        const selectedGroup = this.selectedGroupFromDropdown;
        if (selectedGroup) {
            this.filterRecipientsOnGroupsSelectChange(selectedGroup);
        }
    }
    onAddBtnClicked() {
        if (this.selectedRecipientFromDropdown !== undefined) {
            this.addRecipientClicked.emit(this.selectedRecipientFromDropdown);
        }
        else {
            this.appControllerService.showMessage(this.noRecipientSelectedErrMsg, AlertType.Warning);
        }
    }
    onAddAllBtnClicked() {
        this.addAllRecipientsClicked.emit(this.recipientsForTheRecipientsDropdown);
    }
    resetForm() {
        this.displayFilterGroups = false;
        this.selectedRecipientFromDropdown = undefined;
        this.selectedGroupFromDropdown = undefined;
        this.recipientsForTheRecipientsDropdown = [];
        this.recipients = [];
        this.getRecipients(this.stepMetaRecipientGroups, false);
    }
    sortGroupsAlphabetically() {
        if (this.displayFilterGroups) {
            this.recipientsForTheRecipientsDropdown.sort((a, b) => (a.consolidatedGroup?.localeCompare(b.consolidatedGroup)));
        }
        else {
            this.recipientsForTheRecipientsDropdown.sort((a, b) => (a.name?.localeCompare(b.name)));
        }
    }
    populateGroupsSelect() {
        if (this.stepMetaRecipientGroups.length > 0) {
            this.addRecipientGroups();
        }
        // else {
        //   this.appControllerService.showMessage(this.noGroupsDetectedErrMsg, AlertType.Warning);
        // }
    }
    getRecipients(recipientGroups, autoAddSingleRecipient = true) {
        this.getRecipientsByGroupSubscription = this.recipientListService.getRecipientsByGroup(this.generateFilterObject(recipientGroups)).subscribe({
            next: (data) => {
                this.requestStatusService.showBusySpinner("filterSpinner");
                this.filterBasedOnGroupsMetaData(data.recipients);
                this.populateRecipientsDropDown();
                if (autoAddSingleRecipient) {
                    this.autoAddRecipientWhenFilterHasSingleResult();
                }
                this.requestStatusService.removeBusySpinner("filterSpinner");
            }, error: (error) => {
                this.appControllerService.handleServerErrorMessage(this.componentName, error, CRUDOperation.Add);
            }
        });
    }
    filterBasedOnGroupsMetaData(recipients) {
        const jobId = Number(this.jobId);
        this.recipients = recipients.filter((recipient) => {
            let groupMatchesCriteria = false;
            recipient.groups.forEach(((recipientGroup) => {
                for (const stepMetaGroup of this.stepMetaRecipientGroups) {
                    if (recipientGroup.groupType.toLowerCase() === "external") {
                        if (recipientGroup.groupName === stepMetaGroup.groupName && recipientGroup.groupType === stepMetaGroup.groupType && recipient.jobId === jobId) {
                            groupMatchesCriteria = true;
                            break;
                        }
                    }
                    else {
                        if (recipientGroup.groupName === stepMetaGroup.groupName && recipientGroup.groupType === stepMetaGroup.groupType) {
                            groupMatchesCriteria = true;
                            break;
                        }
                    }
                }
            }));
            if (groupMatchesCriteria) {
                return recipient;
            }
        });
    }
    populateRecipientsDropDown() {
        if (this.recipients) {
            this.recipients.forEach(recipient => {
                recipient.consolidatedGroup = this.createConsolidatedGroups(recipient);
                this.recipientsForTheRecipientsDropdown.push(recipient);
            });
            this.recipientsForTheRecipientsDropdown.sort((a, b) => (a.name?.localeCompare(b.name)));
            this.changeDetectorRef.detectChanges();
        }
    }
    createConsolidatedGroups(recipient) {
        const groups = [];
        recipient.groups.forEach(group => groups.push(group.groupName));
        const consolidatedGroups = groups.join(", ");
        return consolidatedGroups;
    }
    filterRecipientsOnGroupsSelectChange(selectedGroup) {
        if (selectedGroup === SharedConstants.FILTER_DEFAULT) {
            this.recipientsForTheRecipientsDropdown = this.recipients;
        }
        else {
            this.recipientsForTheRecipientsDropdown = this.recipients.filter((recipient) => {
                for (const recipientGroup of recipient.groups) {
                    if (recipientGroup.groupName === selectedGroup) {
                        return recipient;
                    }
                }
            });
        }
        this.sortGroupsAlphabetically();
        this.selectedRecipientFromDropdown = this.recipientsForTheRecipientsDropdown[0];
        this.autoAddRecipientWhenFilterHasSingleResult();
        this.changeDetectorRef.detectChanges();
    }
    autoAddRecipientWhenFilterHasSingleResult() {
        if (this.recipientsForTheRecipientsDropdown.length === 1) {
            this.selectedRecipientFromDropdown = this.recipientsForTheRecipientsDropdown[0];
            this.addRecipientClicked.emit(this.selectedRecipientFromDropdown);
        }
    }
    addRecipientGroups() {
        this.stepMetaRecipientGroups.forEach((group) => {
            if (group.groupName) {
                this.groupsForTheGroupsDropdown.push(group.groupName);
            }
            else {
                this.appControllerService.showMessage(this.groupNameUndefinedErrMsg, AlertType.Warning);
            }
        });
    }
    generateFilterObject(recipientGroups) {
        const recipientSelect = {
            jobId: this.jobId,
            moduleId: +this.appControllerService.selectedModuleID,
            groups: []
        };
        if (recipientGroups.length > 0) {
            recipientGroups.forEach((group, i) => {
                const ggroup = {
                    groupType: group.groupType,
                    groupName: group.groupName
                };
                recipientSelect.groups.push(ggroup);
            });
        }
        return recipientSelect;
    }
    static ctorParameters = () => [
        { type: ChangeDetectorRef },
        { type: RecipientListService },
        { type: RequestStatusService },
        { type: AppControllerService }
    ];
    static propDecorators = {
        stepMetaRecipientGroups: [{ type: Input }],
        addRecipientClicked: [{ type: Output }],
        addAllRecipientsClicked: [{ type: Output }],
        configurableLabel: [{ type: Input }],
        jobId: [{ type: Input }]
    };
};
RecipientListFilterComponent = __decorate([
    Component({
        standalone: false,
        selector: "app-recipient-list-filter",
        template: __NG_CLI_RESOURCE__0,
        changeDetection: ChangeDetectionStrategy.OnPush,
        styles: [__NG_CLI_RESOURCE__1]
    })
], RecipientListFilterComponent);
export { RecipientListFilterComponent };
